import gtm from '@/utils/gtm';
import { useState } from 'react';
import CouponWin from './CouponWin';
import './index.scss';
export default function CouponBtn({
    isLogin = false,
    prefixCls,
    TextA = {},
    listCouponA = [],
    activeData = {},
}: {
    isLogin?: boolean;
    prefixCls?: string;
    TextA?: any;
    listCouponA?: any;
    activeData?: any;
}) {
    const [isOpen, setIsOpen] = useState(false);

    const openHandle = () => {
        setIsOpen(true);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_button',
                type: 'My Rewards Popup',
                list_name: activeData.campaignName,
                button_name: TextA.couponBtn,
            });
        } catch (error) {}
    };
    const closeHandle = () => {
        setIsOpen(false);
    };
    return (
        <>
            <button className={`${prefixCls}-coupon-win-btn`} onClick={openHandle}>
                {TextA.couponBtn}
            </button>
            {isOpen && <CouponWin prefixCls={prefixCls} TextA={TextA} isOpen={isOpen} callback={closeHandle} listCouponA={listCouponA} />}
        </>
    );
}
